<template>
  <div class="tnc-wrapper">
    <h2><span style="font-size: 16pt">Điều khoản &amp; Điều kiện</span></h2>
    <h4>
      <strong><span style="font-size: 12pt">Quy định chung</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Trang web của ch&uacute;ng t&ocirc;i chỉ giới hạn cho c&aacute;c c&aacute;
            nh&acirc;n trong độ tuổi hợp
            ph&aacute;p được x&aacute;c định tại khu vực ph&aacute;p l&yacute; nơi c&aacute; nh&acirc;n đ&oacute; cư
            tr&uacute;.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Trang web của ch&uacute;ng t&ocirc;i kh&ocirc;ng chịu tr&aacute;ch nhiệm đối
            với bất kỳ luật quốc gia, luật
            li&ecirc;n bang hoặc luật quốc tế n&agrave;o bị vi phạm bởi bất kỳ người d&ugrave;ng n&agrave;o sử dụng
            trang web của ch&uacute;ng t&ocirc;i.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Người d&ugrave;ng chịu tr&aacute;ch nhiệm về h&agrave;nh động của m&igrave;nh
            v&agrave; bị r&agrave;ng buộc
            bởi luật ph&aacute;p của quốc gia họ, bao gồm luật ph&aacute;p tiểu bang hoặc c&aacute;c vấn đề ph&aacute;p
            l&yacute;.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Tất cả c&aacute;c đại l&yacute; chịu tr&aacute;ch nhiệm về t&agrave;i khoản
            của c&aacute;c th&agrave;nh
            vi&ecirc;n tương ứng của họ v&agrave; sẽ t&ocirc;n trọng tất cả c&aacute;c cược đ&atilde; được x&aacute;c
            nhận do họ gửi.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Đại l&yacute; kh&ocirc;ng phải l&agrave; đối t&aacute;c của trang web của
            ch&uacute;ng t&ocirc;i. Do
            đ&oacute;, trang web của ch&uacute;ng t&ocirc;i kh&ocirc;ng chịu tr&aacute;ch nhiệm về bất kỳ sự kh&aacute;c
            biệt hoặc tranh chấp n&agrave;o giữa Người chơi v&agrave; Đại l&yacute;.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Người d&ugrave;ng c&oacute; tr&aacute;ch nhiệm bảo vệ ID người d&ugrave;ng
            v&agrave; Mật khẩu của
            m&igrave;nh khỏi việc sử dụng tr&aacute;i ph&eacute;p. Nếu ID người d&ugrave;ng v&agrave; Mật khẩu của người
            d&ugrave;ng bị đ&aacute;nh cắp hoặc bị x&acirc;m phạm, người d&ugrave;ng c&oacute; tr&aacute;ch nhiệm
            li&ecirc;n hệ với đại l&yacute; của m&igrave;nh ngay lập tức. Sau đ&oacute;, đại l&yacute; sẽ thay đổi ID
            người d&ugrave;ng v&agrave; mật khẩu của người d&ugrave;ng.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Trong trường hợp ID người d&ugrave;ng v&agrave; mật khẩu bị đ&aacute;nh cắp,
            người d&ugrave;ng phải chịu
            tr&aacute;ch nhiệm về t&agrave;i khoản tương ứng của m&igrave;nh v&agrave; sẽ t&ocirc;n trọng tất cả
            c&aacute;c cược đ&atilde; x&aacute;c nhận đ&atilde; gửi.</span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">Luật chơi game</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Kết quả tr&ograve; chơi do trang web của ch&uacute;ng t&ocirc;i quyết định sẽ
            l&agrave; kết quả cuối
            c&ugrave;ng v&agrave; mang t&iacute;nh r&agrave;ng buộc.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Trong mọi trường hợp tranh chấp, cả ban quản l&yacute; trang web của
            Ch&uacute;ng t&ocirc;i v&agrave; người
            chơi phải đồng &yacute; rằng cơ sở dữ liệu nhật k&yacute; giao dịch tr&ecirc;n trang web của Ch&uacute;ng
            t&ocirc;i sẽ đ&oacute;ng vai tr&ograve; l&agrave; trọng t&agrave;i cuối c&ugrave;ng trong tranh chấp. Mọi
            tranh chấp phải được giải quyết trong ng&agrave;y kết quả trận đấu được x&aacute;c định. Kh&ocirc;ng
            c&oacute; khiếu nại n&agrave;o sẽ được thực hiện sau ng&agrave;y thi đấu.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Người chơi ho&agrave;n to&agrave;n chịu tr&aacute;ch nhiệm x&aacute;c minh
            t&iacute;nh ch&iacute;nh
            x&aacute;c của tất cả c&aacute;c giao dịch t&agrave;i khoản của m&igrave;nh.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">H&atilde;y nhớ kiểm tra lại cược của bạn xem c&oacute; sai s&oacute;t hoặc
            thiếu s&oacute;t n&agrave;o
            kh&ocirc;ng trước khi gửi ch&uacute;ng qua m&aacute;y t&iacute;nh. Sau khi đặt cược được chấp nhận qua
            m&aacute;y t&iacute;nh, n&oacute; kh&ocirc;ng thể thay đổi hoặc hủy bỏ.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Ch&uacute;ng t&ocirc;i c&oacute; quyền đ&oacute;ng băng hoặc hủy bất kỳ
            t&agrave;i khoản n&agrave;o của
            kh&aacute;ch h&agrave;ng bị ph&aacute;t hiện vi phạm c&aacute;c Điều khoản v&agrave; Điều kiện n&agrave;y,
            tham gia v&agrave;o c&aacute;c hoạt động gian lận, x&acirc;m phạm, tấn c&ocirc;ng, l&agrave;m sai lệch,
            l&agrave;m hỏng c&aacute;c quy tắc ti&ecirc;u chuẩn hoặc li&ecirc;n quan đến c&aacute; cược tổ hợp, dẫn đến
            tất cả số dư t&agrave;i khoản bị đ&oacute;ng băng v&agrave; bị tịch thu. m&agrave; kh&ocirc;ng cần
            th&ocirc;ng b&aacute;o trước.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Chúng tôi có quyền hủy hoặc vô hiệu bất kỳ cược hoặc vé cược nào được xác định
            có liên quan đến cá cược theo nhóm, cá cược phối hợp, thông đồng, gian lận, lạm dụng hệ thống, lợi dụng lỗi
            kỹ thuật, tỷ lệ cược không chính xác hoặc bất kỳ hành vi nào khác nhằm đạt được lợi thế không công bằng. Mọi
            khoản tiền thắng có liên quan có thể bị thu hồi, và tài khoản liên quan có thể bị tạm khóa hoặc chấm dứt.
          </span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">Giới hạn v&agrave; tr&aacute;ch nhiệm ph&aacute;p l&yacute;</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Kh&ocirc;ng ảnh hưởng đến t&iacute;nh tổng qu&aacute;t của những điều
            đ&atilde; n&oacute;i ở tr&ecirc;n,
            trang web của ch&uacute;ng t&ocirc;i sẽ kh&ocirc;ng chịu tr&aacute;ch nhiệm với bất kỳ người n&agrave;o
            trong trường hợp ph&aacute; hoại, bất khả kh&aacute;ng v&agrave;/hoặc về c&aacute;c trường hợp hỏng
            h&oacute;c hoặc hư hỏng hoặc ph&aacute; hủy hệ thống m&aacute;y t&iacute;nh trung t&acirc;m hoặc hồ sơ hoặc
            bất kỳ bộ phận n&agrave;o của trang web của ch&uacute;ng t&ocirc;i. hoặc bất kỳ sự chậm trễ, mất m&aacute;t,
            sai s&oacute;t, thiếu s&oacute;t hoặc bất kỳ nguy&ecirc;n nh&acirc;n n&agrave;o kh&aacute;c do lỗi của bất
            kỳ hệ thống viễn th&ocirc;ng hoặc truyền dữ liệu n&agrave;o hoặc bất kỳ sự chậm trễ n&agrave;o dẫn đến việc
            kh&ocirc;ng nhận được bất kỳ mục n&agrave;o cho một cuộc đua cụ thể.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Trang web của ch&uacute;ng t&ocirc;i sẽ kh&ocirc;ng chịu tr&aacute;ch nhiệm về
            bất kỳ tổn thất n&agrave;o
            do thi&ecirc;n tai, b&ugrave;ng ph&aacute;t chiến sự, bạo loạn, bất ổn d&acirc;n sự, h&agrave;nh động khủng
            bố, h&agrave;nh động của ch&iacute;nh phủ hoặc cơ quan c&oacute; thẩm quyền (bao gồm cả việc từ chối hoặc
            thu hồi bất kỳ giấy ph&eacute;p hoặc sự đồng &yacute; n&agrave;o), ch&aacute;y nổ, lũ lụt, trộm cắp,
            ph&aacute; hoại c&oacute; chủ &yacute;, đ&igrave;nh c&ocirc;ng, bế xưởng v&agrave; đ&igrave;nh c&ocirc;ng
            dưới bất kỳ h&igrave;nh thức n&agrave;o.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Trong trường hợp kết nối mạng, li&ecirc;n lạc, lỗi hệ thống hoặc lỗi con người
            g&acirc;y ra c&aacute;c vấn
            đề li&ecirc;n quan đến đặt cược như chấp nhận cược đ&ocirc;i, cược kh&ocirc;ng thể được x&aacute;c nhận, đặt
            cược sau khi trận đấu bắt đầu, v.v. Ch&uacute;ng t&ocirc;i c&oacute; quyền trong trường hợp đ&oacute; để
            giải quyết c&aacute;c lỗi đ&oacute; trong từng trường hợp cụ thể v&agrave; thực hiện bất kỳ h&agrave;nh động
            n&agrave;o kh&aacute;c để sửa c&aacute;c lỗi đ&oacute;. Ch&uacute;ng t&ocirc;i sẽ kh&ocirc;ng chịu bất kỳ
            tr&aacute;ch nhiệm ph&aacute;p l&yacute; n&agrave;o đối với bạn hoặc bất kỳ b&ecirc;n thứ ba n&agrave;o về
            những sai s&oacute;t đ&oacute;. Nếu bạn gặp phải những lỗi như vậy v&agrave; tiếp tục đặt cược m&agrave;
            kh&ocirc;ng b&aacute;o c&aacute;o với tuyến tr&ecirc;n của m&igrave;nh, bạn sẽ phải chịu tr&aacute;ch nhiệm
            v&agrave; t&ocirc;n trọng mọi kết quả thắng/thua nếu lỗi xảy ra lần nữa.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">C&aacute;c Quy tắc v&agrave; Quy định n&agrave;y cấu th&agrave;nh to&agrave;n
            bộ thỏa thuận v&agrave; sự
            hiểu biết giữa c&aacute;c b&ecirc;n.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Nếu c&oacute; bất kỳ sự kh&aacute;c biệt n&agrave;o giữa phi&ecirc;n bản tiếng
            Anh của c&aacute;c Quy tắc
            v&agrave; Quy định n&agrave;y với bất kỳ phi&ecirc;n bản ng&ocirc;n ngữ n&agrave;o kh&aacute;c th&igrave;
            phi&ecirc;n bản tiếng Anh sẽ thay thế c&aacute;c ng&ocirc;n ngữ kh&aacute;c v&agrave; được coi l&agrave;
            ch&iacute;nh x&aacute;c v&agrave; hợp lệ.</span>
        </p>
      </li>
    </ol>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
  import BurgerMenu from '@/components/burger-menu.vue';
  import { isMobile } from 'mobile-device-detect';
  export default {
    components: {
      BurgerMenu,
    },
    data: () => {
      return {
        isMobile,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .tnc-wrapper {
    padding: 16px 24px;
    box-sizing: border-box;
    height: calc(100% - 56px);
    overflow-y: auto;
  }

  strong,
  h2,
  h4 {
    font-weight: 600;
  }
</style>
